/* eslint-disable react/no-unknown-property */
import { useNavigate } from 'react-router';
// import { useGetCasinoGameById } from 'decryption_protocol_hooks';
// import { AdaptedGame } from 'decryption_protocol/dist/lib/store/casino/entities/games/types';

import HOCImageWithDefault from 'components/HOCs/HOCImageWithDefault';
import DefaultGameImg from 'components/ui/DefaultGameImg';
import { ArrowSvg } from 'react-gldn-kit';

import { isMobileAppSelector } from 'stores/marketing/selectors';
import { useZustandMarketingTabsStore } from 'stores/marketing/store';

import { ERouteNames } from 'Routes/types';

import { useHookFabric } from 'hooks/useHookFabric';

import styles from './VideoBanner.module.css';
import { useEffect, useRef } from 'react';

type Props = {
  gameId: number;
  source: string;
};

const VideoBanner = ({ gameId, source }: Props) => {
  // const game = useHookFabric({
  //   fn: useGetCasinoGameById,
  //   customProps: {
  //     gameId,
  //   },
  // }) as AdaptedGame | null;

  const navigate = useNavigate();

  const jumpToGame = () => {
    // if (!game) {
    //   return;
    // }
    // navigate(ERouteNames.CasinoGame.replace(':gameId', `${game.id}`));
  };

  const isMobileApp = useZustandMarketingTabsStore(isMobileAppSelector);

  const videoRef = useRef(null);

  useEffect(() => {
    const video: any = videoRef.current;

    if (video) {
      // Обход: ручной старт после короткой задержки
      const start = () => {
        video.play().catch((err: any) => {
          console.warn('Manual play failed:', err);
        });
      };

      // iOS WebView требует хотя бы 1 user interaction
      document.addEventListener('touchstart', start, { once: true });

      // Запуск через таймер для Safari или других случаев
      setTimeout(start, 1000);
    }
  }, []);

  return (
    <div className={styles.wrapperCrazyVideoBanner} onClick={jumpToGame}>
      <div className={styles.gameBg} />

      <video
        ref={videoRef}
        playsInline
        webkit-playsinline="true"
        muted
        loop
        preload="metadata"
        style={{
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
          display: 'block',
        }}
      >
        <source src={`/casino/icons-elon/video/${source}`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className={styles.gameWrapper}>
        <div className={styles.leftSide}>
          {/* <HOCImageWithDefault src={game.imageUrl} classes={styles.gameImg}>
            <DefaultGameImg classes={styles.gameImg} gameName={game.name} />
          </HOCImageWithDefault> */}

          {/* <div className={styles.gameInfo}>
            <div className={styles.gameName}>{game.name}</div>
            <div className={styles.providerName}>{game.providerName}</div>
          </div> */}
        </div>

        <ArrowSvg classes={styles.arrow} />
      </div>
    </div>
  );
};

export default VideoBanner;
